module.exports = __webpack_public_path__ + "img/img_zheng@2x.a7223a53.png";